import type { ApiResponse } from '@klaro7/shared-types';

import api from '@/lib/api';

export interface AdminUser {
  id: string;
  email: string;
  role: 'super_admin' | 'admin';
  status: string;
  profile: {
    firstName: string;
    lastName: string;
    avatar?: string;
    phone?: string;
  };
  createdAt: string;
  updatedAt: string;
}

export interface CreateAdminInput {
  email: string;
  password: string;
  role: 'super_admin' | 'admin';
  profile: {
    firstName: string;
    lastName: string;
    phone?: string;
  };
}

export async function createAdmin(data: CreateAdminInput): Promise<void> {
  await api.post('/users', data);
}

export async function getAdmins(): Promise<AdminUser[]> {
  const response = await api.get<ApiResponse<AdminUser[]>>('/users/admins');
  return response.data.data;
}

export async function updateAdminRole(id: string, role: 'super_admin' | 'admin'): Promise<void> {
  await api.put(`/users/${id}`, { role });
}

export async function changeAdminPassword(id: string, password: string): Promise<void> {
  await api.put(`/users/${id}/password`, { password });
}
